import React, { useState, useEffect, useCallback } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useCartStore } from '../context/store';
import api from '../utils/api';
import toast from 'react-hot-toast';

const C = {
  prune:'#4A1942',pruneL:'#6B2E62',pruneD:'#2D0F28',
  or:'#C9A84C',creme:'#FDF6EC',cremeD:'#F5E8D3',cremeMid:'#EDD9BB',
  noir:'#1A0F18',gris:'#5C4A58',grisM:'#8B7A86',grisL:'#C4B8C0',
  vert:'#27AE60',rouge:'#C0392B',
};

const CATEGORIES = [
  { id: '', label: 'Tout voir', icon: '✨' },
  { id: 'wax', label: 'Wax', icon: '🌺' },
  { id: 'bazin', label: 'Bazin', icon: '✨' },
  { id: 'boubou', label: 'Boubou', icon: '👘' },
  { id: 'moderne', label: 'Moderne', icon: '🎽' },
  { id: 'accessoires', label: 'Accessoires', icon: '👜' },
  { id: 'enfants', label: 'Enfants', icon: '🧒' },
];

const SORTS = [
  { value: 'created_at', label: 'Plus récents' },
  { value: 'prix_asc', label: 'Prix croissant' },
  { value: 'prix_desc', label: 'Prix décroissant' },
];

function ProductCard({ product }) {
  const navigate = useNavigate();
  const { addItem } = useCartStore();
  const prix = product.prix_promo || product.prix;
  const hasPromo = !!product.prix_promo;
  const remise = hasPromo ? Math.round((1 - product.prix_promo / product.prix) * 100) : 0;
  const img = product.images?.[0];

  return (
    <div style={{ background: 'white', borderRadius: 16, overflow: 'hidden', border: `1px solid ${C.cremeMid}`, transition: 'all .3s', cursor: 'pointer', display: 'flex', flexDirection: 'column' }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = `0 8px 32px rgba(74,25,66,.15)`; e.currentTarget.style.transform = 'translateY(-4px)'; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
      onClick={() => navigate(`/produit/${product.id}`)}
    >
      {/* Image */}
      <div style={{ position: 'relative', aspectRatio: '3/4', overflow: 'hidden', background: `linear-gradient(135deg, ${C.cremeD}, ${C.cremeMid})` }}>
        {img ? (
          <img src={img} alt={product.nom} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform .4s' }}
            onMouseEnter={e => e.target.style.transform = 'scale(1.06)'}
            onMouseLeave={e => e.target.style.transform = 'scale(1)'}
            onError={e => { e.target.style.display = 'none'; }}
          />
        ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 64, background: `linear-gradient(135deg, ${C.cremeD}, ${C.cremeMid})` }}>
            {CATEGORIES.find(c => c.id === product.categorie)?.icon || '🌺'}
          </div>
        )}
        {/* Badges */}
        <div style={{ position: 'absolute', top: 12, left: 12, display: 'flex', flexDirection: 'column', gap: 6 }}>
          {hasPromo && <span style={{ background: C.rouge, color: 'white', fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 20, fontFamily: 'monospace' }}>-{remise}%</span>}
          {product.stock < 5 && product.stock > 0 && <span style={{ background: '#E67E22', color: 'white', fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 20, fontFamily: 'monospace' }}>Plus que {product.stock}</span>}
          {product.stock === 0 && <span style={{ background: C.grisM, color: 'white', fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 20, fontFamily: 'monospace' }}>Épuisé</span>}
        </div>
        {/* Quick add */}
        <button
          style={{ position: 'absolute', bottom: 12, right: 12, width: 40, height: 40, borderRadius: '50%', background: `linear-gradient(135deg, ${C.prune}, ${C.pruneL})`, border: 'none', cursor: 'pointer', color: C.or, fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: `0 4px 16px rgba(74,25,66,.4)`, opacity: 0, transition: 'opacity .2s' }}
          onMouseEnter={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.parentElement.style.opacity = '1'; }}
          onClick={e => {
            e.stopPropagation();
            if (product.stock === 0) return toast.error('Produit épuisé');
            const taille = product.tailles?.[0] || 'M';
            addItem(product, taille, null, 1);
            toast.success('Ajouté au panier !');
          }}
          title="Ajouter au panier"
        >🛍</button>
      </div>
      {/* Infos */}
      <div style={{ padding: '14px 16px', flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
        <span style={{ fontSize: 10, fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: '.1em', color: C.prune, fontWeight: 600 }}>{product.categorie}</span>
        <h3 style={{ fontFamily: 'Georgia, serif', fontWeight: 400, fontSize: 16, color: C.pruneD, lineHeight: 1.3, margin: 0 }}>{product.nom}</h3>
        {product.description && <p style={{ fontSize: 12, color: C.grisM, lineHeight: 1.5, margin: 0, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{product.description}</p>}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 'auto', paddingTop: 8 }}>
          <span style={{ fontFamily: 'monospace', fontSize: 16, fontWeight: 700, color: C.prune }}>{prix.toLocaleString('fr-CI')} FCFA</span>
          {hasPromo && <span style={{ fontFamily: 'monospace', fontSize: 12, color: C.grisL, textDecoration: 'line-through' }}>{product.prix.toLocaleString('fr-CI')}</span>}
        </div>
        {/* Couleurs */}
        {product.couleurs?.length > 0 && (
          <div style={{ display: 'flex', gap: 4, marginTop: 4 }}>
            {product.couleurs.slice(0, 4).map((c, i) => (
              <div key={i} title={c.nom} style={{ width: 14, height: 14, borderRadius: '50%', background: c.hex, border: `2px solid ${C.cremeD}`, flexShrink: 0 }} />
            ))}
            {product.couleurs.length > 4 && <span style={{ fontSize: 10, color: C.grisM }}>+{product.couleurs.length - 4}</span>}
          </div>
        )}
      </div>
    </div>
  );
}

export default function Shop() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');

  const cat = searchParams.get('categorie') || '';
  const sort = searchParams.get('sort') || 'created_at';
  const LIMIT = 12;

  const load = useCallback(() => {
    setLoading(true);
    const params = new URLSearchParams({ limit: LIMIT, page });
    if (cat) params.set('categorie', cat);
    if (search) params.set('q', search);
    api.get('/products?' + params)
      .then(r => { setProducts(r.data.products || []); setTotal(r.data.pagination?.total || 0); })
      .catch(() => toast.error('Erreur chargement'))
      .finally(() => setLoading(false));
  }, [cat, page, search]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { setPage(1); }, [cat, search]);

  const handleSearch = e => { e.preventDefault(); setSearch(searchInput); };

  return (
    <div style={{ minHeight: '100vh', background: C.creme, paddingTop: 72 }}>
      {/* Header boutique */}
      <div style={{ background: `linear-gradient(135deg, ${C.pruneD} 0%, ${C.prune} 100%)`, padding: '48px 24px 40px', textAlign: 'center' }}>
        <span style={{ fontFamily: 'monospace', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.2em', color: C.or, display: 'block', marginBottom: 12 }}>Notre collection</span>
        <h1 style={{ fontFamily: 'Georgia, serif', fontWeight: 300, fontSize: 'clamp(28px, 5vw, 52px)', color: C.creme, margin: '0 0 24px' }}>
          {cat ? CATEGORIES.find(c => c.id === cat)?.label || 'Boutique' : 'Toute la collection'}
        </h1>
        {/* Barre de recherche */}
        <form onSubmit={handleSearch} style={{ display: 'flex', maxWidth: 480, margin: '0 auto', gap: 0 }}>
          <input value={searchInput} onChange={e => setSearchInput(e.target.value)} placeholder="Rechercher un article..."
            style={{ flex: 1, padding: '12px 20px', border: 'none', borderRadius: '8px 0 0 8px', fontSize: 14, fontFamily: 'DM Sans, sans-serif', outline: 'none', color: C.noir, background: 'white' }} />
          <button type="submit" style={{ padding: '12px 20px', background: C.or, border: 'none', borderRadius: '0 8px 8px 0', cursor: 'pointer', color: C.pruneD, fontWeight: 700, fontSize: 16 }}>🔍</button>
        </form>
      </div>

      <div style={{ maxWidth: 1320, margin: '0 auto', padding: '0 24px 64px' }}>
        {/* Filtres catégories */}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', padding: '24px 0', overflowX: 'auto' }}>
          {CATEGORIES.map(c => (
            <button key={c.id} onClick={() => { setSearchParams(c.id ? { categorie: c.id } : {}); }}
              style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 18px', borderRadius: 'var(--radius-full, 999px)', fontSize: 13, fontWeight: 500, cursor: 'pointer', transition: 'all .2s', whiteSpace: 'nowrap', border: `1.5px solid ${cat === c.id ? C.prune : C.cremeMid}`, background: cat === c.id ? `linear-gradient(135deg, ${C.prune}, ${C.pruneL})` : 'white', color: cat === c.id ? C.or : C.gris, fontFamily: 'DM Sans, sans-serif' }}>
              <span>{c.icon}</span> {c.label}
            </button>
          ))}
          <div style={{ marginLeft: 'auto' }}>
            <select value={sort} onChange={e => setSearchParams(prev => { const p = new URLSearchParams(prev); p.set('sort', e.target.value); return p; })}
              style={{ padding: '8px 14px', border: `1.5px solid ${C.cremeMid}`, borderRadius: 8, fontSize: 13, background: 'white', color: C.gris, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', outline: 'none' }}>
              {SORTS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
            </select>
          </div>
        </div>

        {/* Résultats */}
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 13, color: C.grisM, fontFamily: 'monospace' }}>{total} article{total > 1 ? 's' : ''}</span>
          {search && <button onClick={() => { setSearch(''); setSearchInput(''); }} style={{ fontSize: 12, color: C.rouge, background: 'none', border: 'none', cursor: 'pointer' }}>✕ Effacer la recherche</button>}
        </div>

        {loading ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 20 }}>
            {Array(8).fill(0).map((_, i) => (
              <div key={i} style={{ borderRadius: 16, overflow: 'hidden', background: 'white' }}>
                <div style={{ aspectRatio: '3/4', background: `linear-gradient(90deg, ${C.cremeD} 25%, ${C.cremeMid} 50%, ${C.cremeD} 75%)`, backgroundSize: '400px 100%', animation: 'shimmer 1.4s infinite' }} />
                <div style={{ padding: 16 }}>
                  <div style={{ height: 12, background: C.cremeD, borderRadius: 4, marginBottom: 8, width: '60%' }} />
                  <div style={{ height: 18, background: C.cremeD, borderRadius: 4, marginBottom: 8 }} />
                  <div style={{ height: 14, background: C.cremeD, borderRadius: 4, width: '40%' }} />
                </div>
              </div>
            ))}
          </div>
        ) : products.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '80px 24px' }}>
            <span style={{ fontSize: 64 }}>🌺</span>
            <p style={{ fontFamily: 'Georgia, serif', fontSize: 24, fontWeight: 300, color: C.pruneD, marginTop: 16 }}>Aucun article trouvé</p>
            <p style={{ color: C.grisM, marginTop: 8 }}>Essayez une autre catégorie ou modifiez votre recherche</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 20 }}>
            {products.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        )}

        {/* Pagination */}
        {total > LIMIT && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 40 }}>
            {Array(Math.ceil(total / LIMIT)).fill(0).map((_, i) => (
              <button key={i} onClick={() => setPage(i + 1)}
                style={{ width: 36, height: 36, borderRadius: '50%', border: `1.5px solid ${page === i + 1 ? C.prune : C.cremeMid}`, background: page === i + 1 ? `linear-gradient(135deg, ${C.prune}, ${C.pruneL})` : 'white', color: page === i + 1 ? C.or : C.gris, fontSize: 13, fontWeight: 600, cursor: 'pointer', transition: 'all .2s' }}>
                {i + 1}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
